<template>
  <div
    class="panel panel-default panel-default--transparent"
    :class="{ 'anchor-panel-body': applyNewBorderStyles }"
    role="tabpanel">
    <div class="panel-heading" v-if="header && header.length > 0">
      {{ header }}
    </div>
    <div class="panel-body gb-text-3">
      <slot name="body"/>
    </div>
    <div class="panel-footer goal-footer-text" v-if="footer">
      <slot name="footer"/>
    </div>
    <div class="panel-footer goal-footer-text" v-if="footer2">
      <slot name="footer2"/>
    </div>
    <div class="panel-footer goal-footer-text" v-if="footer3">
      <slot name="footer3"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BigGoal',
  props: {
    header: {
      type: String,
      default: ''
    },
    footer: {
      type: Boolean,
      default: false
    },
    footer2: {
      type: Boolean,
      default: false
    },
    footer3: {
      type: Boolean,
      default: false
    },
    eventContext: {
      type: Object,
      default: () => ({})
    },
    applyNewBorderStyles: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      expandFooter: false
    }
  },
  eventContext() {
    return this.eventContext || {}
  }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';

.panel {
  border: none;
}
.panel-body, .panel-footer {
  border: 1px solid #ddd;
  box-shadow: 1px 1px 1px rgb(0 0 0 / 5%);
}
.panel-body {
  border-radius: 4px 4px 0 0;
  border-bottom: 0px;
}
.panel-footer {
  padding: 0;
  background-color: white;
  border-top: 0;
  border-bottom: 2px solid #d4d4d4;
  position: relative;
}
.panel-heading {
  border-bottom: 0;
}
.goal-footer-text {
  h4 {
    text-transform: uppercase;
    font-size: 14px;
    margin-top: 16px;
  }
}
.collapse-in {
  background-color: gold;
}

.anchor-panel-body {
  border: 1px solid @panel-border-light-gray;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
